export default {
  questionsThemes: [],
  errors: null
};
